import React, { Component } from 'react'
import { connect } from 'react-redux'

import moment from 'moment-timezone'

import Icon from 'components/icon/icon'

import { API_URL } from 'state/api'

class StatusInvoices extends Component {
    formatDateByTimeZone = date => {
        const userTimezone = moment.tz.guess()

        let returnValue = null

        moment.tz.setDefault('Etc/GMT')

        returnValue = moment(date).tz(userTimezone)

        moment.tz.setDefault()

        return returnValue
    }

    render() {
        const {
            account,
            allInvoices
        } = this.props

		return (
			<div className="widget box progress-update">
				<h3>
					Invoices
				</h3>
				<div>
					<ul className="big-task-list no-min-height headertab-list no-padding">
						{ (account.invoices && account.invoices.length) ? 
							account.invoices.map(invoiceId => {
                                if(typeof invoiceId == 'object'){
                                    return null
                                }

                                const invoice = allInvoices[invoiceId]
                                const date = this.formatDateByTimeZone(invoice.date.date)

								return (
									<li 
                                        className="list-item" 
                                        key={invoice.id}
									>
                                        <a href={API_URL+'/accounts/'+account.id+'/getInvoice/'+invoice.id} target="_blank">
                                            <div className="list-item-content">
                                                <h4 className="date">
                                                    <em>
                                                        { date.format('Do MMMM, h:mm a') }
                                                    </em>
                                                    <span>
                                                        { invoice.number }
                                                    </span>
                                                    <div 
                                                        className="message-controls"
                                                        onClick={e => e.stopPropagation()}
                                                    >
                                                        <button
                                                            onClick={_ => {this.deleteUpdate(invoice)}}
                                                        >
                                                            <Icon name="envelope-o" />
                                                        </button>
                                                    </div>
                                                </h4>
                                            </div>
                                        </a>
									</li>
								)
							})
							:
							<li className="list-item empty-banner">
								<h2>
									No progress updates.
								</h2>
								<p>
									Add progress updates to keep a log of how you're tracking.
								</p>
							</li>
						}
					</ul>
				</div>
			</div>   
		)
    }
}

const mapStateToProps = state => {
    return {
        allInvoices: state.account.entities.invoices
    }
}

export default connect(mapStateToProps, null)(StatusInvoices)